module.exports = {
  ALL: [
    {
      name: 'Infobip',
      logo: 'infobip.png',
      amount: {
        MYR: [5, 9, 15, 25, 45],
        THB: [37.45, 52.43]
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/pay/infobip.js